import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: (failureCount, error) => {
        if (error?.status === 401) return false
        return failureCount < 3
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      queryKeyHashFn: (queryKey) => JSON.stringify(queryKey),
    },
    mutations: {
      retry: 1,
    },
  },
})

export default {
  install(app) {
    app.use(VueQueryPlugin, { queryClient })
  },
}
